import React from 'react';
import BgCheckIcon from 'ax/icons/BgCheckIcon.jsx';
import CustomIcon from 'ax/icons/CustomIcon.jsx';
import DataCollectionsIcon from 'ax/icons/DataCollectionIcon.jsx';
import FormIcon from 'ax/icons/FormIcon.jsx';
import HiredIcon from 'ax/icons/HiredIcon.jsx';
import LearningIcon from 'ax/icons/LearningIcon.jsx';
import RecordIcon from 'ax/icons/RecordIcon.jsx';
import ScheduleIcon from 'ax/icons/ScheduleIcon.jsx';
import SignIcon from 'ax/icons/SignIcon.jsx';
import WotcIcon from 'ax/icons/WotcIcon.jsx';
import PartnerIcon from 'ax/icons/PartnerIcon.jsx';
import TechCheckIcon from 'ax/icons/TechCheckIcon.jsx';

const SvgFileIcon = (props) => {
  switch (props.name.toLowerCase()) {
    case 'backgroundcheckerstage':
      return <BgCheckIcon {...props} />;
    case 'onfidostage':
      return <BgCheckIcon {...props} />;
    case 'checkrcanada::stage':
      return <BgCheckIcon {...props} />;
    case 'newcheckrcanada::stage':
      return <BgCheckIcon {...props} />;
    case 'sterlingstage':
      return <BgCheckIcon {...props} />;
    case 'accuratestage':
      return <BgCheckIcon {...props} />;
    case 'customstage':
      return <CustomIcon {...props} />;
    case 'datacollectionstage':
      return <DataCollectionsIcon {...props} />;
    case 'hiredstage':
      return <HiredIcon {...props} />;
    case 'videorecordingstage':
      return <RecordIcon {...props} />;
    case 'schedulerstage':
      return <ScheduleIcon {...props} />;
    case 'documentsigningstage':
      return <SignIcon {...props} />;
    case 'documentsignaturestage':
      return <SignIcon {...props} />;
    case 'learningstage':
      return <LearningIcon {...props} />;
    case 'schoolkeepstage':
      return <CustomIcon {...props} />;
    case 'fountaindocumentsigningstage':
      return <SignIcon {...props} />;
    case 'i9formstage':
      return <FormIcon {...props} />;
    case 'w4federalformstage':
      return <FormIcon {...props} />;
    case 'w4stateformstage':
      return <FormIcon {...props} />;
    case 'wotcstage':
      return <WotcIcon {...props} />;
    case 'multistage':
      return <DataCollectionsIcon {...props} />;
    case 'partnerstage':
      return <PartnerIcon {...props} />;
    case 'techcheckstage':
      return <TechCheckIcon {...props} />;
    default:
      return <div />;
  }
};

export default SvgFileIcon;
